import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Curriculo } from './../_classes/curriculo';
import { CurriculoGruposAq } from './../_classes/curriculo-grupos-aq';
import { Erro } from './../_classes/erro';
import { Util } from './../_classes/util';
import { ServidorService } from './../_servicos/servidor.service';

@Component({
  selector: 'app-curriculo',
  templateUrl: './curriculo.component.html',
  styleUrls: ['./curriculo.component.scss'],
})
export class CurriculoComponent implements OnInit {
  private readonly recurso: string = 'curriculo'; //mesmo que a rota
  percent1: number = 0;
  percent2: number = 0;
  percent3: number = 0;

  carregando = false;
  carregando1 = false;
  carregando2 = false;

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  ultimoErro: Erro = null;
  dataSource$: Observable<Curriculo[]>;
  dataSourceGrupos$: Observable<CurriculoGruposAq[]>;
  displayedColumns: string[] = [
    'dataInicio',
    'ch',
    'nome',
    'dsFinalidades',
    'dtInicioEfeitoFinanceiro',
  ];
  displayedColumnsGrupos: string[] = [
    'seqPercentual',
    'dtInicioEfeitoFinanceiro',
    'snContaAqFolhaAtual',
    'consideracao',
    'snAtingiuOPercentual',
    'cargaHorariaTotal',
  ];

  dataSource: MatTableDataSource<Curriculo>;
  dataSourceGrupos: MatTableDataSource<CurriculoGruposAq>;

  listaItens: Array<string> = new Array<string>();
  listaClasse: Array<string> = new Array<string>();

  itensAjuda = [
    { titulo: 'Período', texto: 'Período de realização do curso' },
    { titulo: 'CH', texto: 'Carga horária do curso' },
    {
      titulo: 'Detalhes',
      texto:
        'Detalhes como nome do curso, instituição, nr do protocolo aqui no regional, data de protocolo e tipo de curso',
    },
    { titulo: 'Finalidade', texto: 'Finalidade do curso' },
    { titulo: 'Financeiro', texto: 'Período a contar financeiramente' },
  ];

  itensAjudaG = [
    {
      titulo: 'Sequencial',
      texto:
        'Cada grupo de cursos (percentual ganho) tem um nº sequencial que o identifica',
    },
    {
      titulo: 'Efeito Financeiro',
      texto: 'Período do efeito financeiro deste grupo de adicional',
    },
    {
      titulo: 'Conta',
      texto: 'Indica se conta ou não para o adicional de treinamento',
    },
    {
      titulo: 'Consideração',
      texto: 'Indica se a folha atual está considerando ou não',
    },
    { titulo: 'Atingiu', texto: 'Indica se atingiu' },
    { titulo: 'Carga', texto: 'Total de carga horária do grupo do adicional' },
  ];

  @ViewChild('pag', { read: MatPaginator, static: true })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @ViewChild('pagG', { read: MatPaginator, static: true })
  paginatorG: MatPaginator;
  @ViewChild(MatSort, { static: true }) sortG: MatSort;

  coresLegenda = [{ legenda: '', cor: '' }];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  periodo(pI: Date, pF: Date): string {
    return Util.periodo(pI, pF);
  }

  periodoStr(pI: string, pF: string): string {
    pI = pI ? pI.trim() : '';
    pF = pF ? pF.trim() : '';
    if (pI != '' && pF != '') {
      return Util.periodo(Util.dataStringToDate(pI), Util.dataStringToDate(pF));
    } else {
      return '';
    }
  }

  ngOnInit() {
    this.atualizar();
  }

  atualizarCarregando() {
    this.carregando = this.carregando1 && this.carregando2;
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }*/

  executarAoCarregarGruposDatasource(x) {
    console.log('Retorno Grupos:', x);
    this.dataSourceGrupos = new MatTableDataSource<CurriculoGruposAq>(x);
    if (this.dataSourceGrupos) {
      this.dataSourceGrupos.paginator = this.paginatorG;
      this.dataSourceGrupos.sort = this.sortG;
      this.dataSourceGrupos.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando1 = false;
    this.atualizarCarregando();
    //console.log('executarAoCarregarGruposDatasource', x);
    let percentuais = x.filter(
      (grupo) => grupo.consideracao == 'Presente'
    ).length;
    /*
    let percentuais = 0;
    x.forEach((element) => {
      if (element.consideracao === 'Presente') {
        percentuais++;
      }
    });
*/
    this.percent1 = 0;
    this.percent2 = 0;
    this.percent3 = 0;
    let horasFuturas = 0;
    let minFuturas = 0;
    //console.log('percentuais', percentuais);

    if (percentuais !== 3) {
      let futuros = x.filter(
        (grupo) =>
          grupo.consideracao == 'Presente' ||
          (grupo.snAtingiuOPercentual == 'S' && grupo.consideracao == 'Futuro')
      );

      futuros.forEach((grupo) => {
        if (grupo.cargaHorariaTotal) {
          horasFuturas =
            horasFuturas + Number(grupo.cargaHorariaTotal.split(':')[0]);
          minFuturas =
            minFuturas + Number(grupo.cargaHorariaTotal.split(':')[1]);
        }
      });
      if (minFuturas > 0) {
        horasFuturas = horasFuturas + Math.floor(minFuturas / 60);
      }
    }

    if (percentuais > 0) {
      this.percent1 = 120;
    } else {
      if (horasFuturas >= 120) {
        this.percent1 = 120;
        horasFuturas = horasFuturas - 120;
      } else {
        this.percent1 = horasFuturas;
        horasFuturas = 0;
      }
    }
    if (percentuais > 1) {
      this.percent2 = 120;
    } else {
      if (horasFuturas >= 120) {
        this.percent2 = 120;
        horasFuturas = horasFuturas - 120;
      } else {
        this.percent1 = horasFuturas;
        horasFuturas = 0;
      }
    }
    if (percentuais > 2) {
      this.percent3 = 120;
    } else {
      if (horasFuturas >= 120) {
        this.percent3 = 120;
        horasFuturas = horasFuturas - 120;
      } else {
        this.percent1 = horasFuturas;
        horasFuturas = 0;
      }
    }
  }

  percentual(valor: number): string {
    return Math.floor((valor * 100) / 120).toString();
  }

  array_unique(array) {
    return array.filter((el, index, arr) => {
      return index === arr.indexOf(el);
    });
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  executarAoCarregarDatasource(x) {
    console.log('resposta', x);
    this.listaItens = x
      .map((item) => item.tipoCurso)
      .filter((value, index, self) => self.indexOf(value) === index);

    this.listaItens.forEach((x) => {
      let item = Util.estiloRandomico(this.listaClasse);
      this.listaClasse.push(item);
    });
    this.dataSource = new MatTableDataSource(x);
    this.carregando2 = false;

    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.atualizarCarregando();
  }

  cor(se: Curriculo) {
    return 'badge ' + this.listaClasse[this.listaItens.indexOf(se.tipoCurso)];
  }

  atualizar() {
    this.ultimoErro = null;

    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );

    this.carregando2 = true;
    this.dataSource$ = this.service
      .listarCurriculo(this.env.servidor.servidorSrh2.numCpf)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.manipularErro();
          return EMPTY;
        })
      );
    this.carregando1 = true;
    this.dataSourceGrupos$ = this.service
      .listarCurriculoGruposAq(this.env.servidor.servidorSrh2.numCpf)
      .pipe(
        tap((a) => this.executarAoCarregarGruposDatasource(a)),
        take(1),
        catchError((e) => {
          this.manipularErro();
          return EMPTY;
        })
      );
  }

  private manipularErro() {
    return (e) => {
      console.error(e);
      this.ultimoErro = new Erro();
      this.ultimoErro.nome = e.name;
      this.ultimoErro.mensagem = e.message;
      this.erros$.next(true);
      return EMPTY;
    };
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  aplicarFiltroG(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceGrupos.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceGrupos.paginator) {
      this.dataSourceGrupos.paginator.firstPage();
    }
  }

  mostrarAjudaModal(tipo: string) {
    if (tipo === 'AQ') {
      this.ajudaService.mostrar(this.itensAjudaG, '');
    } else {
      this.ajudaService.mostrar(this.itensAjuda, '');
    }
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
